/* Virtusx: the header of every page (owner 10-14, round 3: 「每1个界面一开始都是以这种 expand 的方式，然后往下拉的时候才会变成
   pill bar」). At the top of a page the header is the full bar; once the page is scrolled (scrollY 11 or more, the
   homepage's threshold) it gets .solid and site.css turns it into the floating capsule (721 px and wider; phones get the
   full frost bar). While the menu (phones, tablets) is open it gets .open. Loaded from inside the header markup:
     <script src=(window.RD_MEDIA||'')+"/assets/js/header.js" defer></script>
   The first state is set without the morph (.hd-now), so a page opened part way down shows the capsule at once; old
   markup (class="site always") becomes the new one. Scroll is read once per frame, passive. */
(function(){
  var hd=document.getElementById('hd');
  if(!hd||!hd.classList.contains('site'))return;
  var solid=null,queued=false,root=document.documentElement;
  function update(){
    queued=false;
    var s=hd.hasAttribute('data-solid')||(window.pageYOffset||root.scrollTop||0)>10;
    if(s===solid)return;
    solid=s;hd.classList.toggle('solid',s);
  }
  hd.classList.add('hd-now');
  hd.classList.remove('always');
  update();
  getComputedStyle(hd).opacity;   // the first state is styled while the morph is off
  requestAnimationFrame(function(){requestAnimationFrame(function(){hd.classList.remove('hd-now')})});
  addEventListener('scroll',function(){if(!queued){queued=true;requestAnimationFrame(update)}},{passive:true});
  addEventListener('pageshow',update);
  // the menu (a <details>): .open while it is open; .mx while it is expanded, i.e. open and not closing (each page's
  // close() adds .closing for 200 ms before it shuts the <details>). On a phone .mx grows the bar's frost down to hold
  // the links (site.css, 10-14 十三); it is set one frame after the links are laid out and measured (--mnav-h), so the
  // growth starts from the bar every time. The button says whether the menu is expanded (aria-expanded).
  var m=hd.querySelector('details.mnav');
  if(m){
    var sum=m.querySelector('summary'),nav=m.querySelector('nav'),raf=0;
    var size=function(){if(nav&&m.open)hd.style.setProperty('--mnav-h',nav.offsetHeight+'px')};
    var sync=function(){
      var on=m.open&&!m.classList.contains('closing');
      hd.classList.toggle('open',m.open);
      if(sum)sum.setAttribute('aria-expanded',on?'true':'false');
      if(!on){cancelAnimationFrame(raf);raf=0;hd.classList.remove('mx');return}
      if(hd.classList.contains('mx')||raf)return;
      size();
      raf=requestAnimationFrame(function(){raf=0;if(m.open&&!m.classList.contains('closing'))hd.classList.add('mx')});
    };
    m.addEventListener('toggle',sync);
    if(window.MutationObserver)new MutationObserver(sync).observe(m,{attributes:true,attributeFilter:['open','class']});
    addEventListener('resize',size);
    sync();
  }
})();
/* the footer groups on phones (owner 10-15: the Products / Company / Help groups opened in one frame; 「快速又细腻」 like
   the menu). 720 and narrower only, and only with motion allowed: a tap on a group's heading is taken over.
   - open: the <details> opens at once (one layout: its links are laid out and the page under it takes its new place),
     then everything under the group (the next groups, the © row) is moved back up to where it was and slides down
     to its place on transform in 220 ms, cubic-bezier(.2,.8,.2,1); a white cover over the links, its top edge riding
     with the groups under it, uncovers them as it goes (it shrinks from its foot, scaleY). The links come in one after
     another, 25 ms apart from 20 ms, each fading in over 150 ms while it rises 8 px in 180 ms (all in at about
     270 ms; owner: 「不能太慢，速度要快」);
   - close: the links fade out together in 80 ms; from 10 ms the cover and the groups under it go back up in 140 ms on
     cubic-bezier(.4,0,.2,1) (done at 150 ms); then the <details> shuts (one layout, nothing moves). At the end of the
     page, where shutting it would make the browser pull the page down in one jump, the group's height moves instead
     (the page follows it down smoothly, as before 10-16). The chevron turns back at the tap (.f-closing, site.css).
   Smooth on a weak phone (owner 10-16, iPhone: 「下拉出来的时候也没有很顺」): until 10-16 the height moved on every frame,
   so every frame laid out and repainted the footer. Now an open is one layout and then only transform and opacity, on
   the compositor (element.animate). Moves land on whole pixels (linear() steps made here from the curve, one step per
   pixel), so the words never sit between pixels. A tap during a move turns it round from where it is.
   Desktop (721+): untouched (the footer's own script keeps the groups open and stops the taps). Reduced motion, or a
   browser without element.animate: the native instant open / close. Each page's footer script still sets the groups
   open or closed when the width crosses 720; a move under way is dropped then. */
(function(){
  var cols=[].slice.call(document.querySelectorAll('details.f-col'));
  if(!cols.length||!Element.prototype.animate)return;
  var phone=matchMedia('(max-width:720px)'),reduce=matchMedia('(prefers-reduced-motion: reduce)');
  var lin=window.CSS&&CSS.supports&&CSS.supports('transition-timing-function','linear(0,1)');
  // cubic-bezier(x1,y1,x2,y2) as whole-pixel steps over n px: the value is rounded to 1/n where the curve crosses each
  // half step. Without linear() (Safari before 17.2) the smooth curve
  function steps(x1,y1,x2,y2,n){
    var css='cubic-bezier('+[x1,y1,x2,y2].join(',')+')';
    n=Math.round(Math.abs(n));
    if(!lin||n<1||n>600)return css;
    var p=['0 0%'];
    for(var k=1;k<=n;k++){
      var lo=0,hi=1,yt=(k-.5)/n;
      for(var i=0;i<26;i++){var t=(lo+hi)/2,y=3*(1-t)*(1-t)*t*y1+3*(1-t)*t*t*y2+t*t*t;if(y<yt)lo=t;else hi=t}
      var u=(lo+hi)/2,x=(3*(1-u)*(1-u)*u*x1+3*(1-u)*u*u*x2+u*u*u)*100;
      p.push(((k-1)/n).toFixed(4)+' '+x.toFixed(2)+'%',(k/n).toFixed(4)+' '+x.toFixed(2)+'%');
    }
    p.push('1 100%');
    return 'linear('+p.join(',')+')';
  }
  function anim(el,kf,o){try{return el.animate(kf,o)}catch(e){o.easing='ease-out';return el.animate(kf,o)}}
  function ty(el){var m=getComputedStyle(el).transform;if(!m||m==='none')return 0;var v=m.match(/-?[\d.e]+/g);return v?+v[v.length===6?5:13]:0}
  var RISE=steps(.2,.8,.2,1,8),OPEN='cubic-bezier(.2,.8,.2,1)',SHUT='cubic-bezier(.4,0,.2,1)';
  var foot=document.querySelector('footer.site')||document.body,root=document.documentElement;
  cols.forEach(function(d){
    var s=d.querySelector('summary'),run=[],want=d.open,below=[],cover=null,mode='';
    function links(){return [].slice.call(d.querySelectorAll('ul a'))}
    // what sits under the group: its later siblings, and the later siblings of each parent up to the footer
    function under(){
      var out=[],el=d;
      while(el&&el!==foot&&el.parentElement){
        for(var n=el.nextElementSibling;n;n=n.nextElementSibling)if(!/^(SCRIPT|STYLE|TEMPLATE)$/.test(n.tagName))out.push(n);
        el=el.parentElement;
      }
      return out;
    }
    function stop(){run.forEach(function(a){a.onfinish=null;a.cancel()});run=[]}
    function clean(){stop();d.classList.remove('f-anim','f-closing');d.style.removeProperty('--f-head');below=[];mode=''}
    s.addEventListener('click',function(e){
      if(!phone.matches||reduce.matches)return;
      e.preventDefault();
      var head=Math.round(s.getBoundingClientRect().height);
      // where the group's foot is on screen now (a move under way included): its laid-out height plus the lift of what
      // is under it, or its animated height
      var lay=Math.round(d.getBoundingClientRect().height),lift=below.length?Math.round(ty(below[0])):0;
      var from=mode==='h'?lay:lay+lift,ops=links().map(function(a){return +getComputedStyle(a).opacity});
      want=!(run.length?want:d.open);
      stop();
      if(!cover){cover=document.createElement('i');cover.className='f-cover';cover.setAttribute('aria-hidden','true');d.appendChild(cover)}
      d.classList.add('f-anim');
      d.style.setProperty('--f-head',head+'px');
      d.open=true;                                          // laid out open for the whole move
      var full=Math.round(d.getBoundingClientRect().height),span=Math.max(1,full-head);
      below=under();
      var to=want?full:head;
      mode='t';
      if(!want){
        d.classList.add('f-closing');
        // shutting at the very end of the page makes the browser pull the page down: move the height instead there
        var sh=root.scrollHeight-(full-head),pull=scrollY+innerHeight-sh;
        if(pull>1)mode='h';
        links().forEach(function(a,i){run.push(anim(a,[{opacity:ops[i]},{opacity:0}],{duration:80,easing:SHUT,fill:'forwards'}))});
      }else{
        d.classList.remove('f-closing');
        links().forEach(function(a,i){
          var o={duration:150,delay:20+25*i,easing:OPEN,fill:'backwards'};
          run.push(anim(a,[{opacity:ops[i]<1?ops[i]:0},{opacity:1}],o));
          run.push(anim(a,[{transform:'translateY(8px)'},{transform:'none'}],{duration:180,delay:o.delay,easing:RISE,fill:'backwards'}));
        });
      }
      var t=want?{duration:220,delay:0,easing:steps(.2,.8,.2,1,to-from),fill:'both'}:{duration:140,delay:10,easing:steps(.4,0,.2,1,to-from),fill:'both'};
      if(mode==='h'){
        cover.style.display='none';
        run.push(anim(d,[{height:from+'px'},{height:to+'px'}],t));
      }else{
        cover.style.display='';
        var y0=from-full,y1=to-full;
        below.forEach(function(el){run.push(anim(el,[{transform:'translateY('+y0+'px)'},{transform:'translateY('+y1+'px)'}],t))});
        run.push(anim(cover,[{transform:'scaleY('+(-y0/span)+')'},{transform:'scaleY('+(-y1/span)+')'}],t));
      }
      var left=run.length,open=want;   // done when every part has finished (the last link's rise ends after the move)
      run.forEach(function(a){a.onfinish=function(){if(--left)return;if(!open)d.open=false;clean()}});
    });
    function drop(){if(run.length){clean();want=d.open}}
    if(phone.addEventListener){phone.addEventListener('change',drop);reduce.addEventListener('change',drop)}
  });
})();

/* 10-16 (owner: 「那比如说它在下面 footer 按 download 怎么办？」, web_566): the footer's "Download" goes straight to this
   computer's download page, as the Pricing buttons do: Windows -> download-windows.html, Mac -> download-mac.html.
   Phones, tablets and anything not recognised keep software.html#download (there is no phone app). Same words, same
   look. window.vxPlatform() is the one shared check ('windows' | 'mac' | ''), also for the Software / Pricing pages */
(function(){
  window.vxPlatform=function(){
    var ua=navigator.userAgent||'',pf=navigator.platform||'',
        touchMac=/Mac/i.test(pf)&&navigator.maxTouchPoints>1;          // an iPad asking for the desktop site
    if(/iPhone|iPad|iPod|Android|Mobile/i.test(ua)||touchMac)return '';
    if(/Win/i.test(pf)||/Windows/i.test(ua))return 'windows';
    if(/Mac/i.test(pf)||/Macintosh|Mac OS X/i.test(ua))return 'mac';
    return '';
  };
  function go(){
    var p=window.vxPlatform();if(!p)return;
    document.querySelectorAll('footer.site a[href$="/pages/download"]').forEach(function(a){
      a.setAttribute('href',a.getAttribute('href').replace(/software\.html#download$/,'download-'+p+'.html'));
    });
  }
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
})();